<template>
  <div class="details-tab p-4">
    <div class="text-center">

      <a v-if="!!event.can_enroll"
         class="btn btn-primary mr-2 mb-4"
         @click="enrollMyself(event)">
        Register Myself
      </a>
      <a v-if="!!event.can_enroll_others"
         class="btn btn-primary mb-4"
         @click="enrollOthers(event)">
        Register Others
      </a>
    </div>

    <EventOverview :event="event" :hide-trainer="hideTrainer" class="details-pane-table"/>

    <div class="text-center mt-4">
      <a :href="route('catalog.course', { course: event.course_id })"
          class="btn btn-primary">
        View Course
      </a>
    </div>
  </div>
</template>

<script>
import EnrollmentMixin from "mixins/Events/HandlesEventEnrollment";
import EventOverview from "../EventOverview";

export default {
  components: {EventOverview},
  mixins: [EnrollmentMixin],
  props: {
    event: {type: Object, required: true},
    hideTrainer: {type: Boolean, default: false},
  },
  computed: {
    routeParam() {
      return {event: this.event.id};
    },
  },
  methods: {
    showError(msg) {
      this.$modal("AlertModal", {
        alert: {
          type: "danger",
          message: msg,
        },
      })
          .then(() => {
          })
          .catch(() => {
          });
    },
  },
};
</script>